// services/quotationService.js

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Save quotation PDF to backend
 */
export const saveQuotationPdf = async (data) => {
  try {
    const formData = new FormData();
    formData.append("connection_id", data.connectionId);
    formData.append("quote_number", data.quoteNumber);
    formData.append("pdf", data.pdfBlob, `quotation-${data.quoteNumber}.pdf`);

    if (data.notes) {
      formData.append("notes", data.notes);
    }

    if (data.metadata) {
      // Send as individual fields so PHP receives it as an array, not a JSON string.
      // Laravel's `nullable|array` validation rejects a stringified JSON value.
      Object.entries(data.metadata).forEach(([key, value]) => {
        formData.append(`metadata[${key}]`, value);
      });
    }

    const response = await fetch(`${API_BASE_URL}/quotation-pdfs`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error saving quotation PDF:", error);
    throw error;
  }
};

/**
 * Get quotations for a connection
 */
export const getQuotationsByConnection = async (connectionId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/quotation-pdfs/connection/${connectionId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching quotations:", error);
    throw error;
  }
};

/**
 * Update quotation notes
 */
export const updateQuotationNotes = async (id, notes) => {
  try {
    const response = await fetch(`${API_BASE_URL}/quotation-pdfs/${id}/notes`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({ notes }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating notes:", error);
    throw error;
  }
};

export const upsertQuotationNotes = async ({ connectionId, quoteNumber, notes }) => {
  try {
    const response = await fetch(`${API_BASE_URL}/quotation-pdfs/upsert-notes`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        connection_id: connectionId,
        quote_number: quoteNumber,
        notes,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error upserting notes:", error);
    throw error;
  }
};
/**
 * Sync quotation to CRM
 */
export const syncQuotationToCrm = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/quotation-pdfs/${id}/sync-crm`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error syncing to CRM:", error);
    throw error;
  }
};
